import React, { useState } from "react";
import { useAuthStore } from "../../store/authStore";
import { useAuthActions } from "../../features/auth/useAuthActions";
import SetInitialPasswordForm from "../../components/auth/SetInitialPasswordForm";
import ChangePasswordOldForm from "../../components/auth/ChangePasswordOldForm";
import ChangePasswordOTPForm from "../../components/auth/ChangePasswordOTPForm";
import { FaArrowRight } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

export default function PasswordSettingsPage() {

  const user = useAuthStore((state) => state.user);

  // logout را هم از store بگیر
  const logout = useAuthStore((state) => state.logout);

  const {
    setInitialPassword,
    changePasswordWithOld,
    changePasswordWithOTP,
  } = useAuthActions();

  const [mode, setMode] = useState("old");

  const [globalMessage, setGlobalMessage] = useState("");
  const [globalError, setGlobalError] = useState("");

  const navigate = useNavigate();

  // تابع مشترک برای logout و redirect
  const logoutAndRedirect = () => {
    setTimeout(() => {
      logout();

      navigate("/user-login", {
        replace: true,
      });

      // برای پاک شدن کامل state های حافظه و رفرش اپ
      window.location.reload();
    }, 1500);
  };

  const handleInitialPassword = async (data) => {
    setGlobalError("");
    setGlobalMessage("");

    try {
      await setInitialPassword(
        data.newPassword,
        data.newPasswordConfirm
      );

      setGlobalMessage("رمز عبور با موفقیت ثبت شد.");

    } catch (error) {
      setGlobalError(
        error.response?.data?.detail ||
        "ثبت رمز عبور با خطا مواجه شد."
      );
    }
  };

  const handleChangePasswordOld = async (data) => {
    setGlobalError("");
    setGlobalMessage("");

    try {
      await changePasswordWithOld(
        data.oldPassword,
        data.newPassword,
        data.newPasswordConfirm
      );

      setGlobalMessage("رمز عبور با موفقیت تغییر کرد. لطفاً مجدداً وارد شوید.");

      logoutAndRedirect();

    } catch (error) {
      setGlobalError(
        error.response?.data?.detail ||
        "تغییر رمز عبور ناموفق بود."
      );
    }
  };

  const handleChangePasswordOTP = async (data) => {
    setGlobalError("");
    setGlobalMessage("");

    try {
      await changePasswordWithOTP({
        phoneNumber: data.phoneNumber,
        otp: data.otp,
        newPassword: data.newPassword,
        newPasswordConfirm: data.newPasswordConfirm,
      });

      setGlobalMessage("رمز عبور با موفقیت تغییر کرد. لطفاً مجدداً وارد شوید.");

      logoutAndRedirect();

    } catch (error) {
      setGlobalError(
        error.response?.data?.detail ||
        "تغییر رمز عبور ناموفق بود."
      );
    }
  };

  return (
    <div className="flex justify-center py-10 px-4">

      <div className="w-full max-w-md bg-white border rounded-lg p-6 shadow-sm">

        <div className="mb-6 text-center relative">
          <Link to={"/"}>
            <FaArrowRight />
          </Link>

          <h1 className="text-lg font-semibold mb-6 text-center">
            مدیریت رمز عبور
          </h1>
        </div>

        {user?.must_set_password ? (
          <SetInitialPasswordForm onSubmit={handleInitialPassword} />
        ) : (
          <>
            <div className="flex mb-6 border-b">

              <button
                onClick={() => setMode("old")}
                className={`flex-1 py-2 text-sm ${
                  mode === "old"
                    ? "border-b-2 border-blue-600 text-blue-600"
                    : "text-gray-500"
                }`}
              >
                تغییر با رمز فعلی
              </button>

              <button
                onClick={() => setMode("otp")}
                className={`flex-1 py-2 text-sm ${
                  mode === "otp"
                    ? "border-b-2 border-blue-600 text-blue-600"
                    : "text-gray-500"
                }`}
              >
                تغییر با کد پیامک
              </button>

            </div>

            {mode === "old" && (
              <ChangePasswordOldForm onSubmit={handleChangePasswordOld} />
            )}

            {mode === "otp" && (
              <ChangePasswordOTPForm onSubmit={handleChangePasswordOTP} />
            )}
          </>
        )}

        {globalError && (
          <p className="text-red-600 text-sm mt-4 text-center">
            {globalError}
          </p>
        )}

        {globalMessage && (
          <p className="text-green-600 text-sm mt-4 text-center">
            {globalMessage}
          </p>
        )}

      </div>

    </div>
  );
}
